import React from "react"
import { Button, Modal } from "components";
import { Text } from "components/fields";

import "../modals.scss";



export default ({ setModal, modal, form }) => {

	if(form.values.type === "SUBSCRIPTION") {
		return null
	}

	return <>
		<Button onClick={() => setModal(true)} className="w-100" size="large" variant="secondary" iconName="plus" iconPosition="left" >Manage Price Discount</Button>
		<div className="paylixecommerce-note mb-3">Set your product discount here</div>

		<Modal open={modal} closeModal={() => setModal(false)} className="widget-modal">

			<div className="paylixecommerce-modal-header">
				Manage Price Discount
			</div>

			<div className="paylixecommerce-modal-body">
				<div className="price-modal-wrapper">
					<div>
						<div className="paylixecommerce-input-prefix">
							%
						</div>
						<Text name="price_discount" type="number" placeholder="ex: 10%" label="Price Discount" {...form} />
					</div>
					<div>
						<div className="paylixecommerce-cart-icon">
							<a className="unselectable"><i className="fa-regular fa-cart-shopping"></i></a>
						</div>
						{form.values.price_discount ? <div className="paylixecommerce-discount-icon unselectable "><i className="fa-regular fa-tag"></i></div> : null}
						<div className="paylixecommerce-card-container">
							<div className="paylixecommerce-card unselectable">
								<div className="paylixecommerce-card-image placeholder"><i className="fa-light fa-box-taped"></i>
								</div>
								<div className="paylixecommerce-card-info">
									<div className="paylixecommerce-card-title justify-content-center text-center">Example</div>
									<div className="paylixecommerce-card-description justify-content-between">
										<span className={`paylixecommerce-card-price ${form.values.price_discount ? 'with-discount' : ''}`}>
											{form.values.price_discount ? <>
												<i>$10.00</i>${(10 - (10 * form.values.price_discount/100)).toFixed(2)}
											</> : "$10.00"}
										</span>
										<span className="paylixecommerce-card-stock">Stock<i className="fa-solid fa-infinity" style={{ marginLeft: "0.2rem", fontSize: 10, color: "rgb(40, 167, 69)" }}></i></span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="paylixecommerce-modal-footer">

				<div className="widget-footer">
					<Button variant="secondary" size="large" className="mr-3" onClick={() => setModal(false)}>Close</Button>
					<Button size="large" onClick={() => setModal(false)}>Update</Button>
				</div>

			</div>

		</Modal>
	</>

}
